module.exports = __webpack_public_path__ + "img/logo.38d07aef.svg";